// Data para exibição: dd/mm/aaaa. Só formata na tela; o dado guardado (store, mapeador) não muda.
//
// O fuso é fixo em America/Sao_Paulo porque o banco devolve `created_at` em UTC: 2026-09-11T19:33Z é 11/09 em São Paulo,
// mas 2026-01-01T00:00Z é 31/12 do ano anterior. Ler o dia pelo fuso do navegador mudaria o resultado de quem abre a tela fora do Brasil.
const FORMATO = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric' });

const SO_DATA = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATA_E_HORA = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

export function dataBr(valor) {
  if (valor == null || valor === '') return '—';
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? '—' : FORMATO.format(valor);
  if (typeof valor !== 'string') return valor;
  const texto = valor.trim();
  // AAAA-MM-DD não tem hora nem fuso: passar por Date o leria como UTC e, em São Paulo, voltaria um dia.
  const soData = SO_DATA.exec(texto);
  if (soData) {
    const [, ano, mes, dia] = soData;
    if (Number(mes) >= 1 && Number(mes) <= 12 && Number(dia) >= 1 && Number(dia) <= 31) return `${dia}/${mes}/${ano}`;
    return valor;
  }
  if (DATA_E_HORA.test(texto)) {
    const d = new Date(texto);
    if (!Number.isNaN(d.getTime())) return FORMATO.format(d);
  }
  // "manual", "via agente", "via API": não são data e já aparecem como o usuário os conhece.
  return valor;
}
